// extracted by mini-css-extract-plugin
export default {"wrapper":"Work_wrapper__iwUEj"};